// @flow
import React from 'react';
import { INK_TOOLING_MEDIA_URL } from './constants';

type SidebarIconImageProps = {
  src: string;
  alt: string;
  width?: number;
};

export const SidebarIconImage = ({ src, alt, width = 24 }: SidebarIconImageProps) => (
  <img width={width} src={`${INK_TOOLING_MEDIA_URL}/${src}`} alt={alt} />
);

export type SidebarIconItem = {
  id: string;
  name: string;
  icon: React.Node;
  route: string;
  isLive?: boolean;
};

export const sidebarIcons: SidebarIconItem[] = [
  {
    id: 'push-alerts',
    name: 'app push alerts',
    icon: <SidebarIconImage src="apps-2-add-fill-1.svg" alt="Push Alerts" />,
    route: '/notifications'
  },
  {
    id: 'email-alert-templates',
    name: 'email alert templates',
    icon: <SidebarIconImage src="alarm-warning-fill-1.svg" alt="Email Alert Templates" />,
    route: '/inkbox-v2/alert'
  },
  {
    id: 'newsletters',
    name: 'newsletters',
    icon: <SidebarIconImage src="mail-volume-fill-1.svg" alt="Newsletters" />,
    route: '/inkbox-v2/original'
  },
  {
    id: 'swipeable',
    name: 'swipeable stories',
    icon: <SidebarIconImage src="swipeable-stories-filled-icon-3.svg" alt="Swipeable" />,
    route: '/swipeable'
  },
  {
    id: 'liveblog',
    name: 'liveblog',
    icon: <SidebarIconImage src="live.svg" alt="Liveblog" />,
    route: '/ink-blog'
  },
  {
    id: 'app-features',
    name: 'app features',
    icon: <SidebarIconImage src="apps-2-fill-1.svg" alt="App Features" />,
    route: '/sections'
  },
  {
    id: 'pagebuilder',
    name: 'pb scheduler',
    icon: <SidebarIconImage src="calendar-schedule-fill-1.svg" alt="Pagebuilder" />,
    route: '/pb-scheduler'
  },
  {
    id: 'weekend-note',
    name: 'weekend note',
    icon: <SidebarIconImage src="edit-circle-fill-1.svg" alt="Weekend Note" />,
    route: '/weekend-note'
  },
  {
    id: 'apple-news',
    name: 'apple news',
    icon: <SidebarIconImage src="apple-logo.webp" alt="Apple News" />,
    route: '/apple-news'
  },
  {
    id: 'admins-and-dev',
    name: 'admin & dev tools',
    icon: <SidebarIconImage src="settings-5-fill-3.svg" alt="Admins and Dev" />,
    route: '/admin'
  },
];
